export default __webpack_public_path__ + "static/media/deposit-qrcode-step5.a754cbe8.png";